import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'vui-form-fields',
    templateUrl: './form-fields.component.html',
    styleUrls: ['./form-fields.component.scss']
})
export class FormFieldsComponent implements OnInit {

    constructor() {
    }

    ngOnInit() {
    }

}
